<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Gebäudetypen
            </h1>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="gebaeudetyp">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span class="red--text" v-html="getConflictText()"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" :aria-activedescendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('gebaeudetyp.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText(item.errorTypes, item.error, item.id)" v-html="getErrorText(item.errorTypes, item.error, item.id)"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-text="$t('gebaeudetyp.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- STADTPLANPROGRAMM -->
        <div class="d-flex flex-column justify-center">
            <h2 class="my-3">Gebäudetypensuche</h2>
            <autocomplete :search="search" ref="addressInput" @submit="updateGeoLink" placeholder="Straße und Hausnummer" aria-label="Straße und Hausnummer" :get-result-value="getResultValue">
            </autocomplete>
            <v-btn class="mb-3" style="margin-top: 24px;" @click="openGeoportal(_prepareLink(lage))" target="_blank" outlined large color="indigo"><span class="black--text subtitle-1">zum Stadtplanprogramm</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Gebäudetypen</h3><br/>
                            <p>
                            Die Luftbildkarte bietet unter Beachtung der nachfolgenden Definitionen eine Unterstützung bei der Bestimmung des Gebäudetyps
                            für die jeweilige Mietwohnung.
                            Bitte beachten Sie, dass in Ihrem Browser die Option "Javascript" für das Stadtplanprogramm aktiviert ist.
                            </p>
                            <p>
                            Geben Sie bitte zunächst Straße und Hausnummer ein und gehen Sie dann zum Stadtplanprogramm.
                            </p>
                            <p>
                            Die Eingabe eines Buchstabens startet die Adresssuche.
                            Wurde ein eindeutiger Straßenname ausgewählt,
                            ermöglicht die Eingabe eines nachfolgenden Leerzeichens
                            die Auswahl einer Hausnummer.
                            </p>

                            <h3>Hochhaus oder höheres Gebäude</h3><br/>
                            <p>Nach 1948 und vor 1999 fertiggestelltes
                            Gebäude mit mindestens sechs Stockwerken
                            zusätzlich zum Erdgeschoss (E+6). Das Gebäude ist freistehend oder grenzt mit 
                            mindestens einer Seite an ein anderes Gebäude gleicher Bauart an (dies muss nicht 
                            zwingend ein Hochhaus oder ein höheres Gebäude sein).</p>

                            <h3>Wohnblock</h3><br/>
                            <p><strong>a) Freistehender Wohnblock:</strong>
                                Freistehendes Gebäude ohne Aufzug mit größerer zum Gebäude gehöriger Grünfläche 
                                oder gärtnerisch angelegter Fläche (nicht nur schmaler Grünstreifen) mit mehr 
                                als zwei Hausnummern und höchstens 5 Stockwerken zusätzlich zum Erdgeschoss 
                                (E+5).</p>
                            <p><strong>b) Zusammenhängender Wohnblock:</strong>
                                Mit mindestens einer Seite an ein anderes Gebäude gleicher Bauart angrenzendes 
                                Gebäude ohne Aufzug mit größerer zum Gebäude gehöriger Grünfläche oder 
                                gärtnerisch angelegter Fläche (nicht nur schmaler Grünstreifen) mit mehr als 
                                fünf Wohnungen (hier ist die Hausnummer des Gebäudes gemeint, in der sich die 
                                Wohnung befindet) und höchstens 5 Stockwerken zusätzlich zum Erdgeschoss 
                                (E+5).</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { createNamespacedHelpers, mapActions, mapMutations } from 'vuex';
    import { EventBus } from '../eventbus';
    import EnvironmentInfoService from '@/api/EnvironmentInfoService';

    const { mapState } = createNamespacedHelpers('error')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a gebaeudetyp ERROR
        computed: { ...mapState(['gebaeudetyp']),
                    ...mapGetters(['hasPermission'])},
        methods: { ...mapActions('berechnung', ['SELECT_GEBAEUDETYP']),
                    ...mapMutations('error', ['SET_GEBAEUDETYP_ERROR']),
                    ...mapMutations('search', ['SET_QUERY']),
                    ...mapActions('error', ['CHECK_MODERNISIERTEFENSTER_ERROR']),
                    ...mapActions('error', ['CHECK_BAUJAHR_ERROR']) }
    })
    export default class Gebaeudetypen extends Vue {

        get error(){
            return this.hasError(this.selectedData.error)
        }

        get selectedData(){
            return this.items.filter(item => item.id === this.selectedItem)[0]
        }

        data() {
            return {
                index: 5,
                selectedItem: this.$store.state.berechnung.selectedGebaeudetyp,
                selectedError: false,
                lage: this.$store.state.search.query,
                items: [
                    { id: 0,
                      error: {
                          selectedBaujahr: function(el){ return (el < 3 && el != null) || el > 6 },
                          selectedModernisierteFenster: function(el){return el == 0}
                      },
                      errorTypes: [
                          "Baujahr",
                          "ModernisierteFenster"
                      ],
                    },
                    { divider: true},
                    { id: 1},
                    { divider: true},
                    { id: 2},
                ],
                validationError: false,
                expanded: false,
                geokartenUrl: '',
                geokartenGebaeudetypUrl: ''
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        updateGeoLink(result){
            this.lage = result._source?.properties?.address
        }

        openGeoportal(address){
            window.open(this.geokartenGebaeudetypUrl + address);
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(errorTypes, error, id){
            /*
             * select those errorTypes (= different components), whose selected value
             * in the store is matched by the function at the same index in error (of the item)
             */
            let errorType = errorTypes.filter((_, i) => error[Object.keys(error)[i]](this.$store.state.berechnung[Object.keys(error)[i]]));
            return errorType.map(el => this.$t('warning.select',
                { step: this.$t(el),
                  choice: this.$t(el.charAt(0).toLowerCase() + el.substring(1) + '.' +
                          this.$store.state.berechnung['selected' + el]),
                  currentStep: "des Gebäudetyps ",
                  currentChoice: this.$t('gebaeudetyp.' + id)
                })).join("<br/>");
        }

        //when conflict is present its text is depending on the item in the store, not the current selection
        getConflictText(){
            let conflictItem = this.items.filter(item => item.id === this.$store.state.berechnung.selectedGebaeudetyp)[0]
            return this.getErrorText(conflictItem.errorTypes, conflictItem.error, conflictItem.id)
        }

        search(input) {
            this.$data.lage = input;
            const url = this.$root.$children[0].getBackendUrl() + `/api/backend-service/adresssuche?searchString=${input}`;

            return new Promise((resolve) => {
            if (input.length < 3) {
                return resolve([])
            }
            fetch(url)
                .then((response) => response.json()
                    .then(data => {
                        if(!data || !data.hits) {
                            resolve([])
                        }
                        // Extract List from response
                        resolve(data?.hits?.hits)
                    })
                )
            })
        }

        getResultValue(result) {
            return result._source?.properties?.address
        }

        _prepareLink(lage) {
            return lage.replace(' ', '%20')
        }

        geoPostMessage(event, vm){
            if(event.origin !== "https://maps.muenchen.de" && event.origin !== this.geokartenUrl) return;
            if(!event.data.gebaeudetyp) return;
            vm.selectedItem = parseInt(event.data.gebaeudetyp)
            //set in result format
            vm.$refs.addressInput.setValue({ label: event.data.address })
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.addressInput.setValue({ label: this.$store.state.search.query })
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            window.addEventListener('message', event => this.geoPostMessage(event, vm))
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
            if(window.location.hash.split('info=')[1] === "gebaeudetypen"){
                this.$refs.infoPanel.toggle()
                setTimeout(() => {
                    this.$refs.infoPanel.$el.scrollIntoView()
                }, 500);
                this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', true)
            }

            EnvironmentInfoService.getEnvironmentInfo().then((value) => {
                this.geokartenUrl = value.geokartenUrl
                this.geokartenGebaeudetypUrl = value.geokartenGebaeudetypUrl
            }).catch((reason) => {
                console.log(reason)
            });
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedData.id)
            this.SELECT_GEBAEUDETYP({ selectedGebaeudetyp: this.selectedItem, selectedGebaeudetypError: this.selectedData.error })
            this.CHECK_BAUJAHR_ERROR()
            this.CHECK_MODERNISIERTEFENSTER_ERROR()
            this.SET_QUERY(this.lage)
            if(this.error){
                console.log('found gebaeudetyp error')
                this.SET_GEBAEUDETYP_ERROR(true)
                let alert = document.querySelector('.errors')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            } else {
                this.SET_GEBAEUDETYP_ERROR(false)
                this.$router.push('haustyp')
            }
        }

        back() {
            this.$router.push('wohnlage')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }
    }
</script>
